;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.quote.show')
    .controller('ToDepositController', ToDepositController)

  ToDepositController.$inject = ['$uibModalInstance']

  function ToDepositController ($uibModalInstance) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        debounce: 400,
        invoice: angular.copy(self.$resolve.invoice),
        quote: angular.copy(self.$resolve.quote),

        cancel: cancel,
        accept: accept,
        refuse: refuse,
        setPriceOrPercent: setPriceOrPercent,
        setDiff: setDiff,
        checkInput: checkInput,
        toPercent: toPercent,
        toPercentFixed: toPercentFixed,
        resetPrice: resetPrice
      })
    }

    function resetPrice () {
      self.invoice.price = 0
    }
    function checkInput () {
      if (self.invoice.price < 0) {
        self.invoice.price = 0
      } else if (self.invoice.percent) {
        if (self.invoice.price > 100) {
          self.invoice.price = 100
        }
      } else if (self.invoice.price > self.quote.computed.fullTotal) {
        self.invoice.price = self.quote.computed.fullTotal
      }
    }
    function accept () {
      let lines = []
      _.get(self.quote, 'lines', []).forEach((el, i) => {
        if (el.type === 'simple_line') {
          const index = lines.findIndex((element) => element.VAT === el.VAT)
          const price = !el.grant ? el.computed.globalDiscounted : el.computed.totalGrant
          if (index >= 0) {
            lines[index].price.amount = Math.round(lines[index].price.amount + ((priceToPercent() / 100) * price))
          } else {
            lines.push({
              price: {
                currency: 'EUR',
                amount: Math.round((priceToPercent() / 100) * price)
              },
              label: 'acompte sur devis n°' + self.invoice.number + ' (TVA ' + el.VAT + '%)',
              VAT: el.VAT,
              grant: !!el.grant,
              quantity: 1,
              type: 'simple_line',
              unit: 'u'
            })
          }
        } else {
          lines.push(el)
        }
      })
      const toSend = { lines: lines, label: self.invoice.label }
      if (self.invoice.isDeposit) {
        toSend.percent = self.invoice.percent
        toSend.price = self.invoice.price
      }
      $uibModalInstance.close(toSend)
    }

    function setPriceOrPercent (change) {
      self.invoice[change] = false
      self.invoice.price = 0
      if (!self.invoice.amount && !self.invoice.percent) {
        self.invoice.percent = true
      }
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function setDiff () {
      if (self.invoice.percent) {
        return self.quote.computed.fullTotal - (self.quote.computed.fullTotal / 100) * self.invoice.price - getTotal()
      } else {
        return self.quote.computed.fullTotal - self.invoice.price - getTotal()
      }
    }

    function getTotalLine (el, i) {
      let toRemove = 0
      self.quote.invoiceDeposit.forEach(data => {
        if (data.lines[i].total) {
          toRemove += Math.round(data.lines[i].total)
        }
      })
      return Math.round(el.total - toRemove)
    }

    function priceToPercent () {
      if (!self.invoice.percent) {
        return toPercent()
      } else {
        return self.invoice.price
      }
    }

    function getTotal () {
      let acc = 0
      _.get(self.quote, 'invoiceDeposit', []).forEach((el) => {
        acc += Number(el.computed.fullTotal)
      })
      return Math.round(acc)
    }

    function toPercent () {
      return Number(((self.invoice.price || 0) * 100) / self.quote.computed.fullTotal)
    }

    function toPercentFixed () {
      return Number(((self.invoice.price || 0) * 100) / self.quote.computed.fullTotal).toFixed(2)
    }
  }
})(window.angular, window._)
